module.exports = __webpack_public_path__ + "img/枸杞子.324bdc25.jpg";